import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import { formatPromoMessage, validateStep } from '@/utils/domain/promo/promoValidation';
import { refreshNegoValues } from '@/utils/domain/promo/promoValues';
import { isLegacyCampaignInForecastPeriod } from '@/utils/domain/promo/promoForecast';

// The promo rules (#23521) live in the Vue domain only : the step is rendered by Vue on every layout. The legacy keeps
// three calls through `externis.promoRules` : `isValid()` (the wizard gate, fed with `buildPromoSnapshot`), the values of
// the negotiated rows it loads, and the forecast period that makes a campaign visible (sfaHelper.getActivePromos).
// Re-installed on every iframe load, since `externis` is rebuilt with the legacy document.

export const PROMO_RULES_VERSION = 2;

export function exposePromoRulesToLegacy() {
	const externis = iframeDataBridge.getIframeWindow()?.externis;
	if (!externis) return;
	externis.promoRules = Object.freeze({
		version: PROMO_RULES_VERSION,
		validateStep,
		formatMessage: formatPromoMessage,
		refreshNegoValues,
		isLegacyCampaignInForecastPeriod,
	});
}
